import React from 'react';
import styled from 'styled-components';
import percente from "../../assets/images/about/100percente.png"
import years from "../../assets/images/about/5-years.png"

import coustemers from "../../assets/images/about/coustemers.png"
import google from "../../assets/images/about/google.png"

// Styled components
const SectionContainer = styled.div`
  text-align: center;
  padding: 40px 20px;
  background-color: #ffffff; /* White background */
`;

const BadgesContainer = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap; /* Allows wrapping on smaller screens */
  margin-bottom: 20px; /* Space below badges */
`;

const BadgeItem = styled.div`
  text-align: center;
  margin: 10px; /* Space between badges */
`;

const BadgeImage = styled.img`
  width: 130px; /* Width of the badge icon */
  height: auto; /* Maintain aspect ratio */
`;

const BadgeText = styled.p`
  margin-top: 10px;
  font-weight: bold;
  color: #333; /* Darker text for better visibility */
`;

const ServiceInfo = styled.p`
  margin: 5px 0;
  color: #555; /* Slightly lighter text for service info */
  font-size: 0.9rem; /* Smaller font size */
`;

const QualityAndServiceSection = () => {
  return (
    <SectionContainer>
      <BadgesContainer>
        <BadgeItem>
          <BadgeImage src={percente} alt="100% Best Quality" />
          <BadgeText>Best Quality</BadgeText>
        </BadgeItem>

        <BadgeItem>
          <BadgeImage src={years} alt="5 Years Experience" />
          <BadgeText>5 Years Experience</BadgeText>
        </BadgeItem>

        <BadgeItem>
          <BadgeImage src={coustemers} alt="6000+ Customers" />
          <BadgeText>6000+ Customers</BadgeText>
        </BadgeItem>

        <BadgeItem>
          <BadgeImage src={google} alt="Google Reviews" />
          <BadgeText>Google Reviews</BadgeText>
        </BadgeItem>
      </BadgesContainer>
      
    </SectionContainer>
  );
};

export default QualityAndServiceSection;
